import React from 'react';
import { CBadge } from '@coreui/react';

export enum OrderStatusType {
  new = 'new',
  filled = 'filled',
  rejected = 'rejected',
  timeout = 'timeout',
  cancelled = 'cancelled',
  pending = 'pending',
  accepted = 'accepted',
}

interface IColors {
  [key: string]: 'success' | 'danger' | 'primary' | 'warning' | 'secondary';
}

const OrderStatusBadge = ({ status }: { status: OrderStatusType }) => {
  const colors: IColors = {
    new: 'success',
    rejected: 'danger',
    filled: 'primary',
    timeout: 'secondary',
    pending: 'warning',
    cancelled: 'danger',
    executing: 'warning',
  };

  return <CBadge color={colors[status]}>{status.toUpperCase()}</CBadge>;
};

export default OrderStatusBadge;
